<template>
  <div class="relative">
    <Menu v-slot="{ open }">
      <MenuButton>
        <div class="flex cursor-pointer items-center gap-1">
          <span
            v-if="selected"
            class="inline-flex items-baseline gap-1.5 truncate"
          >
            <span class="text-lg font-semibold">{{ selected.sign }}</span>
            {{ selected.name }}
          </span>
          <ChevronDownIcon
            class="ml-1 h-6 w-6 shrink-0 stroke-2 transition-transform"
            :class="{
              'rotate-180': open,
            }"
          />
        </div>
      </MenuButton>

      <MenuItems
        class="absolute bottom-full left-1/2 mb-4 grid min-w-32 -translate-x-1/2 gap-1 rounded-xl bg-white p-2 shadow-xl focus:outline-none"
      >
        <MenuItem
          v-for="item in currencyList"
          :key="`currency-opt-${item.short}`"
          v-slot="{ active }"
        >
          <button
            class="c-btn flex w-full items-baseline gap-2.5 whitespace-nowrap rounded-md text-left text-lg lg:px-3 lg:py-1.5 lg:text-base"
            :class="{
              'bg-gray-200 text-gray-600':
                item.short === currencyStore.selected?.short,
              'hover:bg-gray-100': item.short !== currencyStore.selected?.short,
              'bg-blue-100': active,
            }"
            @click="
              () => {
                currencyStore.updateCurrency(item.short)
              }
            "
          >
            <span class="-ml-0.5 text-lg font-semibold">{{ item.sign }}</span>
            {{ item.name }}
          </button>
        </MenuItem>
      </MenuItems>
    </Menu>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { ChevronDownIcon } from '@heroicons/vue/24/outline'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'

import { useLocaleFeatures } from '/@app'
import { useCurrencyStore } from '/@/stores'

const currencyStore = useCurrencyStore()

const selected = computed(() => currencyStore.selected)

const { currencyList } = useLocaleFeatures()
</script>
